"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.showDiscussion = showDiscussion;
exports.removeDiscussion = removeDiscussion;
exports.default = exports.DiscussionNode = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _reactDom = babelHelpers.interopRequireDefault(require("react-dom"));

var _decorators = require("decorators");

var _promisePolyfill = babelHelpers.interopRequireDefault(require("promise-polyfill"));

var _LoginForm = require("./LoginForm");

var _userProfile = require("user-profile");

var _SurveyModal = babelHelpers.interopRequireDefault(require("components/SurveyModal"));

var _fetch = babelHelpers.interopRequireDefault(require("fetch"));

var _eventDispatcher = babelHelpers.interopRequireDefault(require("event-dispatcher"));

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _temp, _class3, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _temp2, _class5, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _class6, _temp3;

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var DiscussionNode = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(DiscussionNode, _Component);

  function DiscussionNode() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, DiscussionNode);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(DiscussionNode)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "node", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "commentPosted", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "defaultCollapsed", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "trackData", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "discussion", _descriptor5, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "Element", _descriptor6, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(DiscussionNode, [{
    key: "render",
    value: function render() {
      if (this.node) {
        try {
          var ChildNode = require("components/Discussion/node.".concat(this.node.node.child_type)).default;

          return _react.default.createElement(ChildNode, {
            Element: this.Element,
            discussion: this.discussion,
            trackData: this.trackData,
            defaultCollapsed: this.defaultCollapsed,
            node: this.node,
            commentPosted: this.commentPosted
          });
        } catch (e) {}
      }

      return _react.default.createElement("div", null);
    }
  }]);
  return DiscussionNode;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "node", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "commentPosted", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function () {};
  }
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "defaultCollapsed", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "trackData", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "discussion", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "Element", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
exports.DiscussionNode = DiscussionNode;
var TopLevelDiscussionForm = (_class3 = (_temp2 =
/*#__PURE__*/
function (_Component2) {
  babelHelpers.inherits(TopLevelDiscussionForm, _Component2);

  function TopLevelDiscussionForm() {
    var _babelHelpers$getProt2;

    var _this2;

    babelHelpers.classCallCheck(this, TopLevelDiscussionForm);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt2 = babelHelpers.getPrototypeOf(TopLevelDiscussionForm)).call.apply(_babelHelpers$getProt2, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this2, "discussionRoot", _descriptor7, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "commentPosted", _descriptor8, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "discussion", _descriptor9, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "trackData", _descriptor10, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    return _this2;
  }

  babelHelpers.createClass(TopLevelDiscussionForm, [{
    key: "render",
    value: function render() {
      var RootNode = require("components/Discussion/root.".concat(this.discussionRoot.child_type)).default;

      return _react.default.createElement(RootNode, {
        trackData: this.trackData,
        discussionRoot: this.discussionRoot,
        commentPosted: this.commentPosted,
        discussion: this.discussion
      });
    }
  }]);
  return TopLevelDiscussionForm;
}(_react.Component), _temp2), (_descriptor7 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "discussionRoot", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "commentPosted", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function () {};
  }
}), _descriptor9 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "discussion", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "trackData", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class3);
var Discussion = (_class5 = (_temp3 = _class6 =
/*#__PURE__*/
function (_Component3) {
  babelHelpers.inherits(Discussion, _Component3);

  function Discussion() {
    var _babelHelpers$getProt3;

    var _this3;

    babelHelpers.classCallCheck(this, Discussion);

    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    _this3 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt3 = babelHelpers.getPrototypeOf(Discussion)).call.apply(_babelHelpers$getProt3, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this3, "discussionRoot", _descriptor11, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    babelHelpers.initializerDefineProperty(_this3, "userId", _descriptor12, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    babelHelpers.initializerDefineProperty(_this3, "commentPosted", _descriptor13, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    babelHelpers.initializerDefineProperty(_this3, "trackData", _descriptor14, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    babelHelpers.initializerDefineProperty(_this3, "commentFormAtEnd", _descriptor15, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    _this3.state = {
      userId: _this3.userId,
      discussion: null,
      discussionTime: null,
      changeCount: 0,
      canCreateAccount: null
    };
    return _this3;
  }

  babelHelpers.createClass(Discussion, [{
    key: "preventSubmit",
    value: function preventSubmit(event) {
      event.preventDefault();
      return false;
    }
  }, {
    key: "profileUpdated",
    value: function profileUpdated(state) {
      var _this4 = this;

      if (state && state.modal) state.modal.hide();
      (0, _userProfile.userProfileUpdated)(state && state.loggedOut === true).then(function (profile) {
        if (state) {
          var evt;
          if (state.isNewAccount === true) evt = 'account-created';else if (state.isNewAccount === false) evt = 'signed-in';

          if (evt) {
            (0, _eventDispatcher.default)(evt, profile);
          }
        }

        _this4.setState({
          userId: state.userId
        });
      });
    }
  }, {
    key: "showLogin",
    value: function showLogin() {
      (0, _LoginForm.show)().then(this.profileUpdated);
    }
  }, {
    key: "showSignUp",
    value: function showSignUp() {
      (0, _LoginForm.show)('sign-up').then(this.profileUpdated);
    }
  }, {
    key: "sitePropsUpdated",
    value: function sitePropsUpdated(event) {
      var _this5 = this;

      if (_reactDom.default.findDOMNode(this)) {
        if (!document.documentElement.contains(_reactDom.default.findDOMNode(this))) {
          _reactDom.default.unmountComponentAtNode(_reactDom.default.findDOMNode(this));

          return;
        }
      }

      this.setState({
        userId: event.siteProps.userProfile.guest ? null : event.siteProps.userProfile.id
      });
      this.getDiscussionRoot().then(function (node) {
        _this5.watchFeed();
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this6 = this;

      this.discussionMounted = true;
      Discussion.register(this.props.discussionRoot, this);
      $(document).on('sitePropsUpdated', this.sitePropsUpdated);
      (0, _userProfile.getSiteProps)().then(function (siteProps) {
        _this6.setState({
          canCreateAccount: siteProps.hasCreateAccount
        });
      });
      this.getDiscussionRoot().then(function (node) {
        _this6.watchFeed();
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      Discussion.unregister(this.props.discussionRoot);
      clearTimeout(this.feedTimeout);
      this.discussionMounted = false;
      $(document).off('sitePropsUpdated', this.sitePropsUpdated);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this7 = this;

      if (prevProps.discussionRoot != this.props.discussionRoot) {
        Discussion.unregister(prevProps.discussionRoot);
        Discussion.register(this.props.discussionRoot, this);
        clearTimeout(this.feedTimeout);
        this.setState({
          discussion: null,
          discussionTime: null
        }, function () {
          _this7.getDiscussionRoot().then(function (node) {
            _this7.watchFeed();
          });
        });
      } else if (this.props.commentPosted && (this.state.discussionTime != prevState.discussionTime || this.state.changeCount != prevState.changeCount)) {
        this.props.commentPosted();
      }
    }
  }, {
    key: "fetchFeedNow",
    value: function fetchFeedNow() {
      clearTimeout(this.feedTimeout);
      this.fetchFeed();
    }
  }, {
    key: "watchFeed",
    value: function watchFeed() {
      clearTimeout(this.feedTimeout);
      this.feedTimeout = setTimeout(this.fetchFeed, 15000 + 60000 * Math.random());
    }
  }, {
    key: "fetchFeed",
    value: function fetchFeed() {
      var _this8 = this;

      clearTimeout(this.feedTimeout);
      if (!this.discussionMounted) return;

      if (!this.state.discussion) {
        this.watchFeed();
        return;
      }

      (0, _fetch.default)("data/discussion/feed?node=".concat(encodeURIComponent(this.discussionRoot), "&time=").concat(encodeURIComponent(this.state.discussionTime))).then(function (response) {
        if (response.ok) return response.json();
        throw new Error();
      }).then(function (body) {
        _this8.processFeed(body);

        _this8.watchFeed();
      }).catch(function (e) {
        _this8.watchFeed();
      });
    }
  }, {
    key: "processFeed",
    value: function processFeed(feed) {
      var _this9 = this;

      var init = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return new _promisePolyfill.default(function (resolve, reject) {
        try {
          if (!_this9.discussionMounted) {
            resolve(null);
            return;
          }

          _this9.setState(function (state) {
            var didChange = false;

            var processNode = function processNode(node) {
              if (feed.allRecords.indexOf(node.node.id) == -1) {
                didChange = true;
                return false;
              }

              var newChildren = Object.keys(feed.items).filter(function (v) {
                return feed.items[v].parent == node.node.id;
              });

              if (newChildren.length) {
                newChildren.forEach(function (nodeId) {
                  if (node.children.filter(function (v) {
                    return v.node.id == nodeId;
                  }).length) {
                    return;
                  }

                  didChange = true;
                  node.children.push({
                    node: feed.items[nodeId],
                    now: feed.now,
                    children: []
                  });
                });
              }

              var permissionChange = false;
              if (Object.keys(node.node.permissions).length != Object.keys(feed.allPermissions[node.node.id]).length) permissionChange = true;else {
                Object.keys(node.node.permissions).forEach(function (key) {
                  if (node.node.permissions[key] != feed.allPermissions[node.node.id][key]) {
                    permissionChange = true;
                  }
                });
              }

              if (feed.items[node.node.id]) {
                didChange = true;
                node.node = feed.items[node.node.id];
              }

              if (permissionChange) {
                didChange = true;
                node.node.permissions = feed.allPermissions[node.node.id];
              }

              node.children = node.children.filter(processNode);
              node.children.sort(function (a, b) {
                return new Date(a.node.created).getTime() - new Date(b.node.created).getTime();
              });

              switch (node.node.child_type) {
                case 'discussionRoot':
                case 'activityRoot':
                case 'documentActivityRoot':
                  node.children.reverse();
                  break;
              }

              node.now = feed.now;
              return true;
            };

            var discussion;

            if (init == true) {
              discussion = {
                node: feed.items[_this9.discussionRoot],
                children: [],
                now: feed.now
              };
            } else {
              discussion = JSON.parse(JSON.stringify(state.discussion));
            }

            try {
              processNode(discussion);

              if (init || didChange) {
                return {
                  discussion: discussion,
                  discussionTime: feed.now,
                  changeCount: state.changeCount + 1
                };
              }

              return {
                discussionTime: feed.now,
                changeCount: state.changeCount
              };
            } catch (e) {
              if (feed.allPermissions[_this9.discussionRoot] && feed.allPermissions[_this9.discussionRoot].view == false) {
                return {
                  discussion: {
                    node: {
                      id: _this9.discussionRoot,
                      child_type: 'discussionRoot',
                      account: {
                        id: null,
                        fullName: 'System',
                        personTitle: '',
                        icons: [],
                        photo: "/admin/platform/plugins/com.sightworks.5.Channel.DigitalXEBase/resources/images/default-profile-image.jpg"
                      },
                      comment: null,
                      created: new Date().toJSON(),
                      modified: new Date().toJSON(),
                      parent: null,
                      permissions: {
                        view: false,
                        reply: false,
                        delete: false,
                        moderate: false
                      }
                    },
                    children: [],
                    now: feed.now
                  },
                  discussionTime: feed.now,
                  changeCount: 0,
                  deniedView: true
                };
              }

              return {};
            }
          }, function () {
            resolve(true);
          });
        } catch (e) {
          reject(e);
        }
      });
    }
  }, {
    key: "getDiscussionRoot",
    value: function getDiscussionRoot() {
      var _this10 = this;

      if (this._discussionRootInfo) {
        if (this._discussionRootInfo.root == this.discussionRoot && this._discussionRootInfo.userId == this.state.userId) {
          return this._discussionRootInfo.promise;
        }
      }

      this._discussionRootInfo = {
        root: this.discussionRoot,
        userId: this.state.userId,
        promise: new _promisePolyfill.default(function (resolve) {
          clearTimeout(_this10.feedTimeout);

          var loop = function loop() {
            (0, _fetch.default)("data/discussion/feed?node=".concat(encodeURIComponent(_this10.discussionRoot))).then(function (response) {
              if (response.ok) return response.json();
              throw new Error();
            }).then(function (body) {
              if (body) {
                _this10.processFeed(body, true).then(function () {
                  return resolve(_this10.state.discussion);
                }); // resolve(this.state.discussion);


                return;
              }

              throw new Error();
            }).catch(function (err) {
              setTimeout(loop, 0);
            });
          };

          setTimeout(loop, 0);
        })
      };
      return this._discussionRootInfo.promise;
    }
  }, {
    key: "render",
    value: function render() {
      var _this11 = this;

      if (!this.state.discussion) return null;
      return _react.default.createElement("section", {
        className: "discussion"
      }, !this.commentFormAtEnd && (!this.state.userId || this.state.discussion.node.permissions.reply) ? _react.default.createElement("div", {
        className: "comment-form"
      }, !this.state.userId ? _react.default.createElement("form", {
        method: "get",
        onSubmit: this.preventSubmit,
        className: "not-signed-in"
      }, _react.default.createElement("div", null, _react.default.createElement("p", null, this.state.canCreateAccount && _react.default.createElement("span", null, _react.default.createElement("a", {
        onClick: this.showSignUp,
        href: "javascript:void(0)"
      }, "Sign Up"), " or", " "), _react.default.createElement("a", {
        onClick: this.showLogin,
        href: "javascript:void(0)"
      }, "Sign In"), " to leave a comment."))) : _react.default.createElement(TopLevelDiscussionForm, {
        trackData: this.props.trackData,
        commentPosted: this.fetchFeedNow,
        discussionRoot: this.state.discussion.node,
        discussion: this.state.discussion
      })) : null, _react.default.createElement("div", {
        className: "comment-list"
      }, this.state.discussion ? this.state.discussion.children.map(function (node, index) {
        return _react.default.createElement(DiscussionNode, {
          discussion: _this11,
          trackData: _this11.props.trackData,
          defaultCollapsed: index > 0,
          commentPosted: _this11.fetchFeedNow,
          node: node,
          key: node.node.id
        });
      }) : null), this.commentFormAtEnd && (!this.state.userId || this.state.discussion.node.permissions.reply) ? _react.default.createElement("div", {
        className: "comment-form"
      }, !this.state.userId ? _react.default.createElement("form", {
        method: "get",
        onSubmit: this.preventSubmit,
        className: "not-signed-in"
      }, _react.default.createElement("div", null, _react.default.createElement("p", null, this.state.canCreateAccount && _react.default.createElement("span", null, _react.default.createElement("a", {
        onClick: this.showSignUp,
        href: "javascript:void(0)"
      }, "Sign Up"), " or", " "), _react.default.createElement("a", {
        onClick: this.showLogin,
        href: "javascript:void(0)"
      }, "Sign In"), " to leave a comment."))) : _react.default.createElement(TopLevelDiscussionForm, {
        trackData: this.props.trackData,
        commentPosted: this.fetchFeedNow,
        discussionRoot: this.state.discussion.node,
        discussion: this.state.discussion
      })) : null);
    }
  }, {
    key: "leaveReportResponse",
    value: function leaveReportResponse(headerInfo) {
      var _this12 = this;

      var targetNode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var rp;
      if (this.state.userId) rp = _promisePolyfill.default.resolve(this.state.userId);else rp = (0, _LoginForm.show)('sign-up').then(function (_ref) {
        var modal = _ref.modal,
            userId = _ref.userId;
        if (modal) modal.hideNow();

        _this12.setState({
          userId: userId
        });

        return userId;
      });
      return rp.then(function (userId) {
        return new _promisePolyfill.default(function (resolve) {
          var loop = function loop() {
            (0, _fetch.default)("data/discussion/item?node=".concat(encodeURIComponent(_this12.discussionRoot))).then(function (result) {
              return result.ok ? result.json() : null;
            }).then(function (result) {
              return resolve(result.node);
            }).catch(function (e) {
              loop();
            });
          };

          loop();
        });
      }).then(function (node) {
        if (true || node.permissions.reply) {
          new _SurveyModal.default(node, headerInfo, _this12.props.trackData, _this12, {
            parent: targetNode || _this12.discussionRoot,
            child_type: 'report'
          }).show();
        }
      });
    }
  }, {
    key: "leaveSurveyResponse",
    value: function leaveSurveyResponse(headerInfo) {
      var _this13 = this;

      var rp;
      if (this.state.userId) rp = _promisePolyfill.default.resolve(this.state.userId);else rp = (0, _LoginForm.show)('sign-up').then(function (_ref2) {
        var modal = _ref2.modal,
            userId = _ref2.userId;
        if (modal) modal.hideNow();

        _this13.setState({
          userId: userId
        });

        return userId;
      });
      return rp.then(function (userId) {
        return new _promisePolyfill.default(function (resolve) {
          var loop = function loop() {
            (0, _fetch.default)("data/discussion/item?node=".concat(encodeURIComponent(_this13.discussionRoot))).then(function (result) {
              return result.ok ? result.json() : null;
            }).then(function (result) {
              return resolve(result.node);
            }).catch(function (e) {
              loop();
            });
          };

          loop();
        });
      }).then(function (node) {
        if (node.permissions.reply) {
          new _SurveyModal.default(node, headerInfo, _this13.props.trackData, _this13).show();
        }
      });
    }
  }, {
    key: "getNode",
    value: function getNode(id) {
      if (Discussion._nodeCache[id]) return Discussion._nodeCache[id];
      return Discussion._nodeCache[id] = new _promisePolyfill.default(function (resolve) {
        var items = [];

        function descend(node) {
          items.push(node.node);
          node.children.forEach(descend);
        }

        var x = items.filter(function (item) {
          return item.id == id;
        });

        if (x.length) {
          resolve(x[0]);
          return;
        }

        resolve((0, _fetch.default)("data/discussion/item?node=".concat(id)).then(function (r) {
          return r.json();
        }).then(function (r) {
          return r.node;
        }));
      });
    }
  }], [{
    key: "getDiscussion",
    value: function getDiscussion(id) {
      if (!this._activeDiscussions[id]) {
        var x;
        var d = this._activeDiscussions[id] = {
          promise: new _promisePolyfill.default(function (resolve) {
            return x = resolve;
          })
        };

        this._activeDiscussions[id].promise.then(function (value) {
          d.resolve = null;
          return value;
        });

        this._activeDiscussions[id].resolve = x;
      }

      return this._activeDiscussions[id].promise;
    }
  }, {
    key: "register",
    value: function register(id, discussion) {
      if (this._activeDiscussions[id]) {
        if (this._activeDiscussions[id].resolve) {
          this._activeDiscussions[id].resolve(discussion);

          return;
        }
      }

      this._activeDiscussions[id] = null;
      this.getDiscussion(id);

      this._activeDiscussions[id].resolve(discussion);
    }
  }, {
    key: "unregister",
    value: function unregister(id) {
      this._activeDiscussions[id] = null;
    }
  }, {
    key: "createNewApplication",
    value: function createNewApplication(headerInfo, formId, catalogItemId) {
      var asScholarship = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      return (0, _userProfile.getUserProfile)().then(function (_ref3) {
        var id = _ref3.id;
        if (id) return id;else {
          return (0, _LoginForm.show)('sign-up').then(function (_ref4) {
            var userId = _ref4.userId,
                modal = _ref4.modal;
            return _promisePolyfill.default.resolve(modal ? modal.hideNow() : true).then(function () {
              return userId;
            });
          });
        }
      }).then(function (userId) {
        return new _promisePolyfill.default(function (resolve) {
          var loop = function loop() {
            (0, _fetch.default)("data/discussion/form?form=".concat(encodeURIComponent(formId))).then(function (result) {
              return result.ok ? result.json() : null;
            }).then(resolve).catch(function (e) {
              loop();
            });
          };

          loop();
        });
      }).then(function (survey) {
        new _SurveyModal.default(Object.assign(survey, {
          catalogItemId: catalogItemId,
          applicationForm: true,
          asScholarship: asScholarship
        }), headerInfo, null, null).show();
      });
    }
  }]);
  return Discussion;
}(_react.Component), _class6._activeDiscussions = {}, _class6._nodeCache = {}, _temp3), (_descriptor11 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "discussionRoot", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "userId", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "commentPosted", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "trackData", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "commentFormAtEnd", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "preventSubmit", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "preventSubmit"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "profileUpdated", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "profileUpdated"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "showLogin", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "showLogin"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "showSignUp", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "showSignUp"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "sitePropsUpdated", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "sitePropsUpdated"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "fetchFeedNow", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "fetchFeedNow"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "fetchFeed", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "fetchFeed"), _class5.prototype)), _class5);
exports.default = Discussion;

function showDiscussion(element, rootNode, userId, trackData, commentPosted) {
  var additionalProps = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};

  _reactDom.default.render(_react.default.createElement(Discussion, _extends({
    discussionRoot: rootNode,
    userId: userId,
    commentPosted: commentPosted,
    trackData: trackData
  }, additionalProps)), element);
}

function removeDiscussion(element) {
  _reactDom.default.unmountComponentAtNode(element);
}